
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitId_$reflection, LocationId_$reflection, StorageId_$reflection } from "./Shared.js";
import { anonRecord_type, record_type, class_type, bool_type, option_type, list_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";

export class Storage extends Record {
    constructor(Id, Name, Description, QRCodeId, QRCodeIds, LocationId, AssignedUserIds, AccessByUser, IsDeleted, IsSelfService, BusinessUnitId, BusinessUnitName, CreatedAt, UpdatedAt) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.QRCodeId = QRCodeId;
        this.QRCodeIds = QRCodeIds;
        this.LocationId = LocationId;
        this.AssignedUserIds = AssignedUserIds;
        this.AccessByUser = AccessByUser;
        this.IsDeleted = IsDeleted;
        this.IsSelfService = IsSelfService;
        this.BusinessUnitId = BusinessUnitId;
        this.BusinessUnitName = BusinessUnitName;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
    }
}

export function Storage_$reflection() {
    return record_type("Shared.Storage.Storage", [], Storage, () => [["Id", StorageId_$reflection()], ["Name", string_type], ["Description", string_type], ["QRCodeId", string_type], ["QRCodeIds", list_type(string_type)], ["LocationId", option_type(LocationId_$reflection())], ["AssignedUserIds", list_type(string_type)], ["AccessByUser", list_type(string_type)], ["IsDeleted", bool_type], ["IsSelfService", bool_type], ["BusinessUnitId", option_type(BusinessUnitId_$reflection())], ["BusinessUnitName", option_type(string_type)], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")]]);
}

export class CreateStorageDto extends Record {
    constructor(Name, Description, QRCodeIds, LocationId, AssignedUserIds, AccessByUser, IsSelfService, BusinessUnitId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.QRCodeIds = QRCodeIds;
        this.LocationId = LocationId;
        this.AssignedUserIds = AssignedUserIds;
        this.AccessByUser = AccessByUser;
        this.IsSelfService = IsSelfService;
        this.BusinessUnitId = BusinessUnitId;
    }
}

export function CreateStorageDto_$reflection() {
    return record_type("Shared.Storage.CreateStorageDto", [], CreateStorageDto, () => [["Name", string_type], ["Description", string_type], ["QRCodeIds", list_type(string_type)], ["LocationId", option_type(string_type)], ["AssignedUserIds", list_type(string_type)], ["AccessByUser", list_type(string_type)], ["IsSelfService", bool_type], ["BusinessUnitId", option_type(string_type)]]);
}

export class UpdateStorageDto extends Record {
    constructor(Name, Description, QRCodeIds, LocationId, AssignedUserIds, AccessByUser, IsSelfService, BusinessUnitId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.QRCodeIds = QRCodeIds;
        this.LocationId = LocationId;
        this.AssignedUserIds = AssignedUserIds;
        this.AccessByUser = AccessByUser;
        this.IsSelfService = IsSelfService;
        this.BusinessUnitId = BusinessUnitId;
    }
}

export function UpdateStorageDto_$reflection() {
    return record_type("Shared.Storage.UpdateStorageDto", [], UpdateStorageDto, () => [["Name", string_type], ["Description", string_type], ["QRCodeIds", list_type(string_type)], ["LocationId", option_type(string_type)], ["AssignedUserIds", list_type(string_type)], ["AccessByUser", list_type(string_type)], ["IsSelfService", bool_type], ["BusinessUnitId", option_type(string_type)]]);
}

export class StorageUserDetail extends Record {
    constructor(Name, Role, Department, UserId) {
        super();
        this.Name = Name;
        this.Role = Role;
        this.Department = Department;
        this.UserId = UserId;
    }
}

export function StorageUserDetail_$reflection() {
    return record_type("Shared.Storage.StorageUserDetail", [], StorageUserDetail, () => [["Name", string_type], ["Role", string_type], ["Department", string_type], ["UserId", string_type]]);
}

export class StorageDetailDto extends Record {
    constructor(Id, Name, Description, BusinessUnitName, Location, QRCodeIds, AssignedUsers, AccessByUsers, SelfServiceConfiguration) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.BusinessUnitName = BusinessUnitName;
        this.Location = Location;
        this.QRCodeIds = QRCodeIds;
        this.AssignedUsers = AssignedUsers;
        this.AccessByUsers = AccessByUsers;
        this.SelfServiceConfiguration = SelfServiceConfiguration;
    }
}

export function StorageDetailDto_$reflection() {
    return record_type("Shared.Storage.StorageDetailDto", [], StorageDetailDto, () => [["Id", string_type], ["Name", string_type], ["Description", string_type], ["BusinessUnitName", option_type(string_type)], ["Location", option_type(anonRecord_type(["LocationId", string_type], ["Name", string_type]))], ["QRCodeIds", list_type(string_type)], ["AssignedUsers", list_type(StorageUserDetail_$reflection())], ["AccessByUsers", list_type(StorageUserDetail_$reflection())], ["SelfServiceConfiguration", anonRecord_type(["IsGlobalSelfService", bool_type], ["IsStorageSelfService", bool_type])]]);
}

export class RemoveQrCodesDto extends Record {
    constructor(QrCodes) {
        super();
        this.QrCodes = QrCodes;
    }
}

export function RemoveQrCodesDto_$reflection() {
    return record_type("Shared.Storage.RemoveQrCodesDto", [], RemoveQrCodesDto, () => [["QrCodes", list_type(string_type)]]);
}

